







































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import RuleGroup from '@/domain/scripts/entity/rule-group.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import ManagementRuleGroup from '../../rule-configuration/management-rule-group.component.vue';

@Component({
  components: {
    MainButton, ManagementRuleGroup,
  },
})
export default class NewRuleGroup extends Vue {
  @Prop() businessUnitId!: string;

  @Prop() ruleGroup?: RuleGroup;

  @Prop() editModeValue!: boolean;

  @Prop() previewModeValue!: boolean;

  contentValid: boolean = false;

  parametersValid: boolean = false;

  ruleGroupToEdit: RuleGroup = RuleGroup.of({});

  created() {
    if (this.ruleGroup) {
      this.ruleGroupToEdit = this.ruleGroup;
    }
  }

  get titleText() {
    let title = 'Novo agrupamento de cálculo';
    if (this.editModeValue) title = 'Editar agrupamento de cálculo';
    if (this.previewModeValue) title = 'Visualizar agrupamento de cálculo';
    return title;
  }

  back() {
    this.$emit('back')
  }
}
